import { css, html, LitElement } from "lit";
import { Task } from "@lit/task";

import { executeInviteCoFounder } from "./invite-cofounder.requests";
import { ref, createRef } from "lit/directives/ref.js";
import Check from "../../utils/assets/img/icon/check-green.svg";
import { getInvitationTokenList } from "../../utilities/requests/invitation-tokens/get-invitation-token-list";
import "./invited-cofounder";
import { resendInvitationToken } from "../../utilities/requests/invitation-tokens/resend-invitation-token";
import { removeInvitationToken } from "../../utilities/requests/invitation-tokens/remove-invitation-token";

export default class InviteCofounder extends LitElement {
  #invitesTask = new Task(this, {
    task: async ([], { signal }) => {
      return await getInvitationTokenList();
    },
    args: () => [],
    onComplete: (results) => {
      console.log("InviteCofounder: invited users result:", results);
      if (results && results.length > 0) {
        this.invitedFounders = results.map((item) => item.email);
        console.log(this.invitedFounders, "invitedFounders");
      }
    },
  });

  static styles = css`
    sl-dialog::part(body) {
      padding-top: 0;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer/Edge */
      overflow: -moz-scrollbars-none; /* Older Firefox versions */
    }
    sl-dialog::part(body)::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }

    .form-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .form-content > .msg-error {
      color: red;
      font-size: 14px;
      font-weight: bold;
      margin-top: -10px;
      margin-bottom: 0px;
    }

    .success-message {
      padding: 0px 10px 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }

    .success-message > sl-icon {
      font-size: 54px;
    }

    .success-message > p {
      margin: 0px;
      text-align: center;
      line-height: 18px;
    }
    .control-blue-button::part(base) {
      background: #1d52f7;
      border-radius: 32px;
      border: 1px solid #1d52f7;
      color: white;
      line-height: 160%;
      font-size: 16px;
      padding: 3px 12px;
      display: flex;
      align-items: center;
    }
    .sl-input-container::part(form-control-help-text) {
      color: #222429;
      padding: 4px 12px 2px;
      line-height: 140%;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      top: 0;
    }
    .sl-input-container::part(form-control-input) {
      padding-top: 10px;
    }
    .sl-input-container::part(input) {
      top: 10px;
      text-overflow: ellipsis;
      flex-grow: 0;
      width: 100%;
      margin-right: 10px;
    }
    .sl-input-container::part(suffix) {
      margin-left: auto;
    }
    .sl-input-container::part(base) {
      height: 62px;
      display: flex;
    }
    .sl-input-container::part(base) {
      background: #f1f2f4;
      border: 1px solid #f1f2f4;
      border-radius: 12px;
      padding: 10px 12px;
      height: 58px;
      align-items: center;
    }
    .sl-input-container::part(form-control-label) {
      display: none;
    }

    .loading-container {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .invited-users-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 20px;

      & p,
      h3 {
        margin: 0;
      }

      & .description {
        font-size: 14px;
        font-weight: 400;
        color: #5a616e;
        line-height: 150%;
      }

      & .invited-users {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
    }
  `;

  static properties = {
    open: { type: Boolean },
    coFounderEmail: { type: String },
    isSubmitting: { type: Boolean },
    msgError: { type: String },
    invitedFounders: { type: Array },
  };

  constructor() {
    super();

    this.invitedFounders = [];

    this.coFounderEmail = "";
    this.isSubmitting = false;
    this.isSuccessfullySubmitted = false;
    this.msgError = "";
    this.close = () => {};
    this.timer = null;
  }

  formRef = createRef();

  updated(changedProperties) {
    if (changedProperties.has("open")) {
      if (this.open === true) {
        this.#invitesTask.run();
        this.isSuccessfullySubmitted = false;
      }
    }
  }

  handleClose() {
    this.coFounderEmail = "";
    this.msgError = "";
    clearTimeout(this.timer);
    this.close();
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(event, "event");

    if (this.isSubmitting) return;

    // Basic email validation
    const email = this.coFounderEmail.trim();
    const isValidEmail = email && email.includes("@");
    if (!isValidEmail) return;

    this.msgError = "";
    this.isSubmitting = true;
    this.isSuccessfullySubmitted = false;

    const { error, data } = await executeInviteCoFounder(email);

    this.isSubmitting = false;

    if (data?.error || error) {
      const msgError = data?.error || error || "An error occurred";
      this.msgError = msgError;
      return;
    }

    this.isSuccessfullySubmitted = true;

    this.timer = setTimeout(() => {
      this.handleClose();
      clearTimeout(this.timer);
    }, 5000);
  };

  async handleResendInvite(e, email) {
    let container = e.target;
    console.log("invite-cofounder: handleResendInvite, email: ", email);

    let response;
    try {
      response = await resendInvitationToken(email);
      console.log("Response in handleResendInvite, ", response);

      if (!response || response?.error) {
        container.response = "error";
      } else container.response = "success";
    } catch (error) {
      console.log("Error in handleResendInvite, ", error);
      container.response = "error";
    }
  }

  async handleDeleteInvite(e, email) {
    let container = e.target;
    container.loading = true;
    console.log("invite-cofounder: handleDeleteInvite, email: ", email);

    let response;
    try {
      response = await removeInvitationToken(email);
      console.log("Response in handleDeleteInvite, ", response);
      this.invitedFounders = [...this.invitedFounders].filter(
        (item) => item !== email
      );
    } catch (error) {
      console.log("Error in handleDeleteInvite, ", error);
      container.response = "error";
    }
    container.loading = false;
  }

  renderForm() {
    return html`
      ${this.renderInvitedUsers()}
      <form
        @submit=${(e) => {
          e.preventDefault();
          this.handleSubmit(e);
        }}
        ${ref(this.formRef)}
      >
        <div class="form-content">
          <sl-input
            class="sl-input-container"
            label="Email"
            type="email"
            required
            autofocus
            .value=${this.coFounderEmail}
            .disabled=${this.isSubmitting}
            placeholder="Enter a email"
            @sl-change=${(e) => (this.coFounderEmail = e.target.value)}
          ></sl-input>
          <button
            type="submit"
            style="display: none;"
            id="hidden-submit"
          ></button>
          <sl-button
            class="control-blue-button"
            slot="footer"
            variant="primary"
            type="submit"
            @click=${() => {
              if (this.formRef.value?.requestSubmit) {
                this.formRef.value.requestSubmit();
              } else {
                const hiddenSubmit =
                  this.shadowRoot.querySelector("#hidden-submit");
                hiddenSubmit.click();
              }
            }}
            .disabled=${this.isSubmitting}
          >
            Invite
          </sl-button>
          ${this.msgError
            ? html`<p class="msg-error">${this.msgError}</p>`
            : ""}
        </div>
      </form>
    `;
  }

  renderSuccessfullyMessage() {
    return html`
      <div class="success-message">
        <sl-icon src=${Check}></sl-icon>
        <p>
          An invitation has been sent to
          <span style="font-weight: bold;">${this.coFounderEmail}</span>.
        </p>
      </div>
    `;
  }

  renderInvitedUsers() {
    return html`<div class="invited-users-container">
      <h3>Invited users:</h3>
      ${this.#invitesTask.render({
        pending: () => html`<div class="loading-container">
          <sl-spinner
            style="font-size: 1.5rem; --track-width: 4px; --indicator-color: #88aff2; --track-color: #d4e6ff;"
          ></sl-spinner>
          <p>Loading...</p>
        </div>`,
        complete: () => {
          return this.invitedFounders.length > 0
            ? html` <p class="description">
                  You can resend the invitation or delete the user.
                </p>
                <div class="invited-users">
                  ${this.invitedFounders.map(
                    (item) =>
                      html`<invited-cofounder
                        @handle-cofounder-button=${(e) => {
                          let detail = e.detail;
                          return detail.type === "delete"
                            ? this.handleDeleteInvite(e, detail.email)
                            : this.handleResendInvite(e, detail.email);
                        }}
                        .email=${item}
                      ></invited-cofounder>`
                  )}
                </div>`
            : html`<p>There are no invited users yet.</p>`;
        },
        error: (error) =>
          html`<div class="loading-container">
            <p style="color: coral">Oops, something went wrong: ${error}</p>
          </div>`,
      })}
    </div>`;
  }

  render() {
    return html`
      <sl-dialog .open=${this.open} @sl-hide=${this.handleClose}>
        <span slot="label">
          <span>Invite a co-founder</span>
        </span>
        ${this.isSuccessfullySubmitted
          ? this.renderSuccessfullyMessage()
          : this.renderForm()}
      </sl-dialog>
    `;
  }
}

customElements.define("invite-cofounder", InviteCofounder);
